module.exports = __webpack_public_path__ + "static/media/sent.04d57f0f.svg";